import React from 'react';
import {Redirect} from 'react-router-dom';

import {createRoutes} from '../@crema/utility/Utils';
import {authRouteConfig} from './auth';
import {initialUrl} from '../shared/constants/AppConst';
import {settingsListConfig } from './clinician/Settings';
import {helpSupportConfig } from './clinician/HelpSupport';
import { errorPagesConfigs } from './errorPages';
import { appointmentsConfig } from './clinician/Appointments';
import { patientsConfig } from './clinician/Patients';
import { consultationConfig } from './clinician/Consultation';
import { dashboardConfig } from './clinician/Dashboard';
import { communicationConfig } from './clinician/Communication';
import {billingsPaymentsConfig} from './clinician/BillingsPayments';
import {reviewsRatingsConfig} from './clinician/ReviewRatings';
import { practitionerviewConfig } from './clinician/PractitionerView';
import { oakTreeReferralsConfig } from './clinician/OaktreeReferral';
import { selfReferralsConfig } from './clinician/SelfReferrals';

const routeConfigs = [
  ...authRouteConfig,
  ...settingsListConfig,
  ...appointmentsConfig,
  ...errorPagesConfigs,
  ...patientsConfig,
  ...consultationConfig,
  ...dashboardConfig,
  ...communicationConfig,
  ...billingsPaymentsConfig,
  ...reviewsRatingsConfig,
  ...practitionerviewConfig,
  ...helpSupportConfig,
  ...oakTreeReferralsConfig,
  ...selfReferralsConfig
];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={initialUrl} />,
  },
  {
    component: () => <Redirect to='/error-pages/error-404' />,
  },
];

export default routes;
